(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-registration-form"] && !Shopify.designMode) return;
  try {
    
  // JavaScript for toggling sections and handling dynamic fields and file upload
  document.addEventListener('DOMContentLoaded', function () {
    const textEntrySection = document.getElementById('textEntry');
    const fileUploadSection = document.getElementById('fileUpload');
    const fileInput = document.getElementById('fileInput');
    const uploadStatus = document.getElementById('uploadStatus');
    const progressBar = document.getElementById('progress');
    const uploadedFiles = document.getElementById('uploadedFiles');
    const studentNameArray = [];
    const studentEmailArray = [];

    // Toggle between Text Entry and File Upload
    document.getElementById('textEntryRadio').addEventListener('change', function () {
      textEntrySection.style.display = 'block';
      fileUploadSection.style.display = 'none';
    });

    document.getElementById('fileUploadRadio').addEventListener('change', function () {
      textEntrySection.style.display = 'none';
      fileUploadSection.style.display = 'block';
    });

    // Function to add dynamic fields for student name and email
    let studentCount = 2; // Start from 1

  document.getElementById('addStudentBtn').addEventListener('click', function () {
    const studentFields = document.createElement('div');
    studentFields.classList.add('input-group');

    studentFields.innerHTML = `
      <input type="text" name="contact[student-name${studentCount}]" class="col-md-6" placeholder="Student Name ${studentCount}" required>
      <input type="text" name="contact[student-email${studentCount}]" class="col-md-6" placeholder="Student Email ${studentCount}" required>
      <button type="button" class="btn btn-outline-danger removeStudentBtn"><i class="fa-solid fa-minus"></i></button>
    `;

    document.getElementById('studentFields').appendChild(studentFields);

    // Remove student field
    studentFields.querySelector('.removeStudentBtn').addEventListener('click', function () {
      studentFields.remove();
      // Note: studentCount is not decremented to keep names unique
    });

    studentCount++; // Increment after adding
  });
    // Handle file upload and progress bar
    fileInput.addEventListener('change', function () {
      const file = fileInput.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('files[]', file);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://rosybrown-louse-801309.hostingersite.com/pmbiomedical/api_upload.php', true);

        xhr.upload.addEventListener('progress', function (e) {
          if (e.lengthComputable) {
            const percent = (e.loaded / e.total) * 100;
            progressBar.style.width = percent + '%';
            uploadStatus.textContent = `Uploading... ${Math.round(percent)}%`;
          }
        });

        xhr.onload = function () {
          if (xhr.status === 200) {
            const response = JSON.parse(xhr.responseText);
            if (response.success) {
              const uploadedFile = response.uploaded[0]; // Get the first (and only) file
              if (uploadedFile) {
                // Display file name
                uploadedFiles.innerHTML = `<a target="_blank" href=${uploadedFile.url}>${uploadedFile.name}</a>`;

                // Store URL or full object as needed
                document.getElementById('uploaded-files-urls').value = uploadedFile.url;

                // Optional logging
                console.log('File name:', uploadedFile.name);
                console.log('File URL:', uploadedFile.url);
              }
            } else {
              uploadStatus.textContent = 'Error during upload!';
            }
          } else {
            uploadStatus.textContent = 'Error during upload!';
          }
        };

        xhr.send(formData);
      }
    });

    // Dynamic Course Title Detection and Form Adjustment
    const courseTitleInput = document.querySelector('input[name="contact[course-title]"]');
    const courseLabel = document.getElementById('courseLabel');
    const courseSelectWrapper = document.querySelector('select[name="contact[met-course]"]').closest('.col-md-6');
    const courseSelect = document.querySelector('select[name="contact[met-course]"]');
    const versionSelectWrapper = document.querySelector('select[name="contact[met-course-version]"]').closest('.col-md-6');
    const versionSelect = document.querySelector('select[name="contact[met-course-version]"]');
    const dateWrapper = document.querySelector('input[name="contact[course-start-date]"]').closest('.col-md-6');
    const courseTitleWrapper = courseTitleInput.closest('.col-md-6');

    // Store original options
    const originalCourseOptions = `
      <option value="100 Series">100 Series</option>
      <option value="200 Series">200 Series</option>
      <option value="300 Series">300 Series</option>
      <option value="400 Series">400 Series</option>
    `;

    const originalVersionOptions = `
      <option value="6-Weeks 100% Online">6-Weeks 100% Online</option>
      <option value="6-Weeks 100% Online With VR Labs">6-Weeks 100% Online With VR Labs</option>
      <option value="6-Weeks Online With 1 Week in person training">6-Weeks Online With 1 Week in person training</option>
      <option value="6-Weeks Online With VR Labs and 1 Week in person training">6-Weeks Online With VR Labs and 1 Week in person training</option>
    `;

    function updateFormBasedOnCourseTitle() {
      const courseTitle = courseTitleInput.value.toLowerCase().trim();

      // Reset to default first
      courseLabel.textContent = 'MET Course';
      courseSelect.innerHTML = originalCourseOptions;
      versionSelect.innerHTML = originalVersionOptions;
      courseSelectWrapper.style.display = 'block';
      versionSelectWrapper.style.display = 'block';
      dateWrapper.style.display = 'block';
      courseTitleWrapper.style.display = 'block';

      // 1. Check for MET courses (100, 200, 300, 400)
      if (courseTitle.includes('met 100') || courseTitle.includes('met 200') || 
          courseTitle.includes('met 300') || courseTitle.includes('met 400')) {
        // Keep default (everything shows as normal)
        return;
      }

      // 2. Check for DENT courses
      if (courseTitle.includes('dent 100') || courseTitle.includes('dent 200') || courseTitle.includes('dent 300')) {
        courseLabel.textContent = 'Dent Course';
        courseSelect.innerHTML = `
          <option value="100">100 Series</option>
          <option value="200">200 Series</option>
          <option value="300">300 Series</option>
        `;
        versionSelectWrapper.style.display = 'none';
        return;
      }

      // 3. Check for Linear Accelerator
      if (courseTitle.includes('linear accelerator')) {
        courseLabel.textContent = 'Linear accelerator Course details';
        courseSelect.innerHTML = `
          <option value="Beginner (Level 1)">Beginner (Level 1)</option>
          <option value="Introductory (level 2)">Introductory (level 2)</option>
          <option value="Intermediate (level 3)">Intermediate (level 3)</option>
        `;
        versionSelectWrapper.style.display = 'none';
        return;
      }

      // 4. Check for Biomedical/Server/Security
      if (courseTitle.includes('biomedical information systems analysing and design') || 
          courseTitle.includes('server') || 
          courseTitle.includes('security')) {
        courseSelectWrapper.style.display = 'none';
        versionSelect.innerHTML = `
          <option value="With 1 week in person training">With 1 week in person training</option>
          <option value="Without hand-on training">Without hand-on training</option>
        `;
        versionSelectWrapper.style.display = 'block';
        return;
      }

      // 5. Any other title - show only date
      if (courseTitle && !courseTitle.includes('met')) {
        courseSelectWrapper.style.display = 'none';
        versionSelectWrapper.style.display = 'none';
        courseTitleWrapper.style.display = 'none';
        return;
      }
    }

    // Listen for changes on course title input
    courseTitleInput.addEventListener('input', updateFormBasedOnCourseTitle);
    courseTitleInput.addEventListener('change', updateFormBasedOnCourseTitle);

    // Run on page load in case title is pre-filled
    updateFormBasedOnCourseTitle();

    // Hide course version when "400 Series" is selected (only for MET courses)
    courseSelect.addEventListener('change', function() {
      const courseTitle = courseTitleInput.value.toLowerCase().trim();
      // Only apply 400 Series logic if we're in MET mode
      if (courseTitle.includes('met') && courseSelect.value === '400 Series') {
        versionSelectWrapper.style.display = 'none';
      } else if (courseTitle.includes('met')) {
        // For other MET series, show version
        versionSelectWrapper.style.display = 'block';
      }
      // Otherwise, let the main function handle it
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
